<template>
  <q-dialog
    :visible="isVisible"
    :title="title"
    width="600px"
    :innerScroll="false"
    :contentLoading="loading"
    @close="onCancel"
    @cancel="onCancel"
    @confirm="onConfirm"
  >
    <el-form
      ref="addForm"
      :model="addForm"
      :rules="rules"
      :disabled="isView"
      label-width="80px">
      <el-form-item label="标题" prop="title">
        <el-input v-model.trim="addForm.title" size="small" :maxlength="500"></el-input>
      </el-form-item>
      <el-form-item label="描述" prop="remark">
        <el-input v-model.trim="addForm.remark" size="small" :maxlength="500"></el-input>
      </el-form-item>
      <el-form-item label="类型" prop="imgLinkType">
        <div :class="addForm.imgLinkType == '2' ? 'typeBox' : ''">
          <el-radio  v-model.trim="addForm.imgLinkType" label="1">链接跳转</el-radio>
          <el-radio  v-model.trim="addForm.imgLinkType" label="2">上传视频</el-radio>
          <el-upload
            v-if="addForm.imgLinkType == '2'"
            class="upload-demo"
            action=""
            :show-file-list="false"
            :http-request="videoUploadImg"
            accept="video/mp4, video/avi, video/wmv, video/flv"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </div>
      </el-form-item>
      <el-form-item label="链接" prop="imgLinkUrl">
        <el-input v-model.trim="addForm.imgLinkUrl" size="small" :maxlength="1000"></el-input>
      </el-form-item>
      <el-form-item label="轮播顺序" prop="sortNo">
        <el-input-number
          class="form-input"
          v-model="addForm.sortNo"
          size="small"
          :controls="false"
          :min="1"
          :max="9999"
          :precision="0"
        />
      </el-form-item>
      <el-form-item label="图片" prop="imgUrl">
        <el-upload
          class="prizeImg-uploader"
          action=""
          accept="image/gif, image/jpeg, image/png"
          :show-file-list="false"
          :http-request='uploadImg'
          >
          <img v-if="addForm.imgUrl" :src="addForm.imgUrl" class="prizeImg">
          <i v-else class="el-icon-plus prizeImg-uploader-icon"></i>
        </el-upload>
      </el-form-item>
    </el-form>
  </q-dialog>
</template>

<script>
import {assignValue} from '@/utils/'
export default {
  name: 'CRUDEdit',
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    modifyData: Object,
    // 1:新增  2:修改  3:查看
    actionType: Number
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
    title() {
      const titleMap = {
        1: '新增',
        2: '修改',
        3: '查看',
      };
      return titleMap[this.actionType];
    },
    isView() {
      return this.actionType == 3;
    }
  },
  data() {
    return {
      addForm: {
        rollingId: '',
        title: '',
        remark: '',
        imgLinkUrl: '',
        imgUrl: '',
        sortNo: '',
        imgLinkType: 1
      },
      rules: {
        title: [
          {required: true, message: '标题不能为空', trigger: 'blur'}
        ],
        sortNo: [
          {required: true, message: '轮播顺序不能为空', trigger: 'blur'}
        ],
        imgUrl: [
          {required: true, message: '图片不能为空', trigger: 'change'}
        ],
      },
      loading: false
    }
  },
  methods: {
    init() {
      if (this.modifyData) {
        this.initModifyData();
      }
    },
    initModifyData() {
      assignValue(this.addForm, this.modifyData);
    },
    videoUploadImg(file) {
      let a = /\.(mp4|avi|wmv|flv)$/;
      const isType = a.test(file.file.name);
      if (!isType) {
        this.$message.error("请上传正确的视频格式!");
        return
      }
      this.loading = true;
      this.$api.common.uploadVideo(file.file)
          .then(({ data}) =>{
            console.log(data)
            this.addForm.imgLinkUrl = data.fileUrl || '';
          })
          .finally(_ => {
            this.loading = false;
          });
      console.log(file)
    },
    uploadImg(file){
      const isLt2M = file.file.size / 1024 / 1024 < 3;
      let a = /\.(jpg|jepg|gif|png)$/;
      const isType = a.test(file.file.name);
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 3MB!");
        return
      }
      if (!isType) {
        this.$message.error("请上传jpg/png图片!");
        return
      }
      this.loading = true;
      this.$api.common.uploadImg(file.file)
          .then(({ data}) =>{
            this.addForm.imgUrl = data[0] && data[0].fileUrl || '';
            this.$refs.addForm.clearValidate('imgUrl');
          })
          .finally(_ => {
            this.loading = false;
          });
    },
    onCancel() {
      this.isVisible = false;
    },
    onConfirm() {
      if (this.loading) {
        return;
      }

      this.$refs.addForm.validate((valid) => {
        if (!valid) return;
        let params = {
          ...this.addForm
        };

        this.loading = true;
        this.$api.carouselImage
          .save(params)
          .then(({ data }) => {
            const message = this.modifyData ? '修改成功': '创建成功';
            this.$notify.success({
              title: '成功',
              message,
            })
            this.isVisible = false
            this.$emit('success')
          })
          .finally(_ => {
            this.loading = false;
          });
      })
    },
  },
  created() {
    this.init()
  },
}
</script>

<style lang="stylus" scoped>
.form-input
  width 120px
.input-number
  width 120px
  >>> .el-input__inner
    text-align left
.typeBox {
  display: flex;
  align-items: center;
}
.prizeImg-uploader
  >>>.el-upload {
    border: 1px dashed  #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  &:hover 
    border-color: #0bb78e;
  .prizeImg-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 130px;
    height: 130px;
    line-height: 130px;
    text-align: center;
  }
  .prizeImg {
    width: 130px;
    height: 130px;
    display: block;
  }
</style>